// extracted by mini-css-extract-plugin
module.exports = {"btnSuperUser":"index__btnSuperUser__2oL7c","headerWrapper":"index__headerWrapper__2dMr6"};